export default __webpack_public_path__ + "media/images/select-53510586beae852ee49af1acecfef453.svg";